// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3itDQ","buttons":"styles_buttons__fEbNm"};